import { useEffect } from 'react';
import useShowToast from 'framework/base/hooks/useShowToast';
import AryToastTypes from 'framework/base/constants/AryToastTypes';
import { useFirebaseMessaging } from './FirebaseMessagingProvider';

const FirebaseNotificationListener = () => {
  const { lastNotification } = useFirebaseMessaging();
  const { showToast } = useShowToast();

  useEffect(() => {
    if (!lastNotification) return;

    const { notification, data } = lastNotification;

    const title = notification?.title || data?.title || 'Moneyx';
    const body = notification?.body || data?.body || '';

    const message = [title, body].filter(Boolean).join('\n');

    showToast(message, AryToastTypes.INFO, 6000);
  }, [lastNotification]);

  return null;
};

export default FirebaseNotificationListener;
